export default {
  // 模块名称
  taskCenter: {
    // 按钮类
    button: {
      save: '保存',
      reset: '重置',
      conform: '确定',
      cancel: '取消',
      prompt: '提示',
      whole: '全选',
      search: '查询',
      close: '关闭',
      review: '通过',
      refuse: '不通过',
      assign: '指派',
      frame: '框选',
      export: '导出'
    },
    // 文字标签类
    label: {
      count: '数量',
      creator: '指派人',
      doPerson: '执行人',
      data: '创建日期',
      taskStatus: '任务状态',
      priority: '优先级',
      taskType: '任务类型',
      modify: '修改',
      review: '审核',
      delete: '删除',
      start: '启动',
      close: '关闭',
      detail: '详情',
      noStart: '未启动',
      wait: '待审核',
      executing: '执行中',
      add: '添加',
      success: '成功',
      dealWitn: '任务已处理完成',
      taslDetail: '任务详情',
      creators: '指派人：',
      taskTypes: '任务类型：',
      taskStatuss: '任务状态：',
      taskName: '任务名称',
      taskNames: '任务名称',
      taskPriority: '优先级：',
      taskVisibility: '可见性：',
      createTime: '指派时间：',
      modifyTime: '实际完成时间',
      areaDevGroupName: '区域：',
      desc: '详情描述：',
      comment: '评审意见：',
      operator: '执行人：',
      action: '执行动作：',
      descs: '描述：',
      file: '相关文件:',
      deviceName: '设备名称：',
      alarmLevel: '报警级别：',
      alarmTypeText: '报警类型：',
      alarmTime: '报警时间：',
      urgent: '催办',
      resDetail: '资源详情',
      doPersons: '执行人员',
      doDetail: '执行明细',
      alarmDetail: '告警明细',
      executor: '执行人编号',
      executorName: '执行人姓名',
      status: '执行情况',
      finishTime: '完成时间',
      urgentFinish: '催办成功',
      taskTeview: '任务审核',
      doPersonsStaus: '执行状态',
      score: '考评等级',
      conmments: '复核意见：',
      olevel: '一级',
      tlevel: '二级',
      thrlevel: '三级',
      folevel: '四级',
      flevel: '五级',
      alarmDetailLevel: '告警级别',
      alarmDetailType: '告警类型',
      groupChoice: '从分组选择',
      mapChoice: '从地图选择',
      abovefile: '相关文件',
      taskNamess: '任务名称：',
      taskVisibilitys: '可见性',
      requiredStartTimeProp: '要求开始时间',
      chooseArea: '选择区域',
      mapChoices: '地图选择',
      taskDesc: '任务描述',
      closeReson: '关闭原因：',
      to: '至',
      no: '序号',
      taskStartTime: '任务启动时间',
      taskCreateTime: '任务创建时间',
      statuss: '状态',
      closeTask: '关闭任务',
      noData: '暂无数据',
      exporting: '正在导出'
    },
    // 提示类
    placeholder: {
      chooseDate: '选择日期',
      taskName: '请输入任务名称',
      choosePlease: '请选择',
      inputPlease: '请输入',
      enterContent: '请输入内容',
    },
    // 消息类
    message: {
      statusRe: '任务状态已刷新！',
      deleteWarn: '确定要删除吗？',
      deleteOk: '删除成功',
      cancelDel: '已取消删除',
      startTask: '确定要启动任务吗？',
      taskSucc: '任务启动成功',
      reSuc: '审核成功',
      timeMore: '开始时间不能大于结束时间',
      disableNull: '复核意见不能为空！',
      commentLen: '复核意见长度介于0-100之间',
      choosePerson: '请选择执行人员',
      taskNameWoed: '任务名称不能包含特殊字符！',
      enterLen: '请输入4-50个字符！',
      deviceInfoLen: '设备名称信息长度介于8到30之间',
      chooseName: '请输入设备名称',
      chooseAlarmLevel: '请选择告警级别',
      chooseAlarm: '请选择告警类型',
      chooseStart: '请选择开始时间',
      choosePriority: '请选择优先级',
      chooseVisibilitys: '请选择可见性',
      chooseTime: '请选择时间',
      chooseType: '请选择任务类型',
      choosePersons: '请框选保卫人员',
      taskLength: '任务描述长度介于0-500之间',
      chooseArea: '请选择区域!',
      enterStart: '请填写要求开始时间',
      startEnd: '要求开始时间至少大于当前时间！',
      searchFail: '查询区域信息失败。',
      dealSuc: '任务已处理完成',
      taskEAnd: '告警状态消除，任务结束',
      closeLen: '任务关闭原因长度介于0-255之间',
      closeReason: '请选择关闭原因',
      uploadFail: '上传失败',
      suffixErr: '图片格式限定为JPG，JPEG，PNG，BMP,视频格式限定为MP4',
      sizeErr: '图片大小限定为2M',
      countErr: '图片个数不能超过10个',
      countErrs: '视频个数不能超过3个',
      notSupport: '您的浏览器不支持 video 标签。',
      videoBiger: '视频大小限定为',
      size: 'M',
      createDate: '未输入创建日期,默认导出最近7天数据?',
      export30: '导出数据时间跨度不可超过30天',
      selectdate: '请选择完整的创建日期'
    },
    // 标题类
    title: {
      allTasks: '所有任务',
      noFinishTask: '未完成任务',
      finishTask: '已完成任务',
      assignTask: '我指派的任务',
      onlyShow: '仅显示我指派的',
      assignTasks: '指派任务',
      choose: '选择',
      taskRecords: '任务记录'
    }
  }
}
